import React, { useEffect } from "react";
import classNames from "classnames";
import Portal from "../Portal";
import { FadeInUp, MoveInRight } from "../Transitions";
import { getOtherProperties } from "../common/Utils";
import { PopupProps } from "./PropsType";

export default function Popup(props: PopupProps) {
  const {
    className,
    children,
    direction = "up",
    prefixCls = "bm-Popup",
    visible,
    ...other
  } = props;
  const styleClass = classNames(prefixCls, className);
  const otherProps = getOtherProperties(other, ["onClose", "onOpen"]);
  const Component = direction === "up" ? FadeInUp : MoveInRight;

  useEffect(() => {
    if (props.visible) {
      if (props.onOpen) {
        (props.onOpen as () => void)();
      }
    } else {
      if (props.onClose) {
        (props.onClose as () => void)();
      }
    }
  }, [props.visible]);

  return (
    <Portal mountNode={document.body} visible={visible}>
      <div className={styleClass} {...otherProps}>
        <Component in={visible}>
          <div className={`${prefixCls}-panel`} key="Popup-panel">
            {children}
          </div>
        </Component>
      </div>
    </Portal>
  );
}
